module.exports = __webpack_public_path__ + "img/c6.eeb985d5.png";